import { render } from "./teacherQrcode.vue?vue&type=template&id=2597bdc4&scoped=true"
import script from "./teacherQrcode.vue?vue&type=script&lang=js"
export * from "./teacherQrcode.vue?vue&type=script&lang=js"

import "./teacherQrcode.vue?vue&type=style&index=0&id=2597bdc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2597bdc4"]])

export default __exports__